import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import authState from 'signoxe/reducers/authState';
import { loginUser } from '../../actions';
import { AuthPage } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { getAuthState, getPageTitle, getProfile } from '../../selectors';


const easyboardUrls = [
  "app.signoxe.local",
  "localhost",
  "app.test.easyboard.co.in",
  "app.easyboard.co.in"
 ]

 const hostname = window.location.hostname

class LoginPage extends React.Component {
  static propTypes = {
    loginUser: PropTypes.func.isRequired,
    authState: PropTypes.object,
    history: PropTypes.object.isRequired,
  };

  handleLogin = (e) => {
    e.preventDefault();
    if (!this.loginForm.checkValidity()) return;
    const username = this.usernameInput.value;
    const password = this.passwordInput.value;

    let instance = this;

    
    this.props.loginUser(username, password).then((res) => {      
      if(this.props.authState.otpNeeded){
        this.props.history.push('/one-time-code')
      }
     
      if (this.props.profile && this.props.profile.features && this.props.profile.features.multiregion && this.props.profile.multiregion_switch) {
        localStorage.setItem('multiregion_switch', this.props.profile.multiregion_switch);
        // this.props.history.push("/channels");
      } else
        localStorage.setItem('multiregion_switch', "false");
    
        const deviceReportSlug = localStorage.getItem("device_report_slug");
        if (deviceReportSlug) {
          this.props.history.push(`/device-email-reports/${deviceReportSlug}`);
        }
        const is_checker = localStorage.getItem('is_checker');
        console.log("is_checker", is_checker)

        if(is_checker === "true"){
          localStorage.removeItem("is_checker")
          this.props.history.push("/checker")
        }
       
        else{
          localStorage.removeItem("is_checker")
          this.props.history.push("/assets");
        }

    }, err => {

    });
  }


  render() {
    // console.log("Helel--", easyboardUrls.includes(hostname))
    return (
      <AuthPage heading="Login" isHost={easyboardUrls.includes(hostname)}>
        <form onSubmit={this.handleLogin} className="form" ref={(elem) => this.loginForm = elem}>
          <input autoFocus
                 id="username"
                 name="username"
                 required="required"
                 ref={(elem) => this.usernameInput = elem}
                 placeholder="Username"
                 type="text" className="username" disabled={this.props.authState.message || this.props.authState.isLoading}/>
          <input id="password"
                 name="password"
                 required="required"
                 ref={(elem) => this.passwordInput = elem}
                 placeholder="Password"
                 type="password" disabled={this.props.authState.message || this.props.authState.isLoading}/>
          <div className="error">
            {this.props.authState.error}
          </div>
          <div style={{color: 'green'}}>
            {this.props.authState.message}
          </div>
          <Box className="actions" direction="row" justifyContent="space-between"
               alignItems="center">
            <a className="forgot-password" href="/forgot-password">Forgot Password</a>
            <Button primary submit onClick={this.handleLogin} isDisabled={this.props.authState.isLoading}>
              { this.props.authState.isLoading ?
                  <i className="fa fa-refresh fa-spin" style={{color: 'white'}}></i>
                :
               " Log In"
            }
            </Button>
          </Box>
        </form>
      </AuthPage>
    );
  }
}

export default connect((state) => ({
    authState: getAuthState(state),
    title: getPageTitle(state),
    profile: getProfile(state)
  }), {
    loginUser,
  },
)(LoginPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/LoginPage/index.js